let sectionHeader = {
    id: '#section-header',
    name: 'section header'
};

let section1 = {
    id: '#section-1',
    name: 'section 1',
};

let section2 = {
    id: '#section-2',
    name: 'section 2'
};


var layer1 = promokit.layer({
    el: '.p-layer',
    buttons: '.p-btn__point',
    render: true,
});


window.mypoint = function (num) {
    var $mypoint = $('.my-point');
    var _num = num.toString();
    if($mypoint.children().length > 0)
        $('.my-point span').remove();
    for(var j = 0; j < 6 - _num.length; j++)
        $mypoint.prepend("<span>0</span>");
    for(var i = 0; i < _num.length; i++)
        $mypoint.append("<span>" + _num[i] + "</span>");
};

window.remove = function () {
};

var page = promokit.page({
    type: 'basic',

    game: 'lineage',

    menu: true,

    cnb: true,

    topButton: true,

    headerButton: {
        el: '.header-button',
        home: true,
        event:true,
        sns: true,
        theme: 'black'
    },

    footer: {
        fixed: false,
        theme:'black'
    },

    caution: '#section-caution',

    components: [
        sectionHeader,
        section1,
        section2,
    ],
});


// WEBPACK FOOTER //
// ./src/js/signature.js